export default "__VITE_ASSET__137e6137__"